import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import { Link, animateScroll as scroll } from "react-scroll";
import { Cross as Hamburger } from 'hamburger-react';
import logo from './assets/img/frz-logo-morelines.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/* Theme variables */
import './theme/variables.css';

/* App styling */
import './App.css';

/* Custom Components */
import Home from './pages/home/Home';

function App() {

    const [isNavbarExpanded, setIsNavbarExpanded] = useState(false);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 991);
    const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);

    const updateIsDesktop = () => {
        setIsDesktop(window.innerWidth > 991);
    };

    useEffect(() => {
        window.addEventListener("resize", updateIsDesktop);
        return () => {
            window.removeEventListener("resize", updateIsDesktop);
        }
    });

    return (
        <>
            <ToastContainer
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false} />
            <Navbar className="navbar" expand="lg" fixed="top" expanded={isNavbarExpanded}>
                <Navbar.Toggle className="nav" aria-controls="basic-navbar-nav" onClick={() => setIsNavbarExpanded(!isNavbarExpanded)}>
                    <Hamburger color="white" toggled={isHamburgerOpen} toggle={setIsHamburgerOpen}></Hamburger>
                </Navbar.Toggle>
                {isDesktop ?
                    (<Container className="links-container">
                        <Navbar.Collapse>
                            <Nav>
                                <Link
                                    className="nav-link"
                                    to="title-section"
                                    spy={true}
                                    smooth={true}
                                    offset={-100}
                                    duration={500}
                                    onClick={() => {
                                        setIsNavbarExpanded(false);
                                        setIsHamburgerOpen(false);
                                    }
                                    }
                                >HOME</Link>
                                <Link
                                    className="nav-link"
                                    to="about-section"
                                    spy={true}
                                    smooth={true}
                                    offset={-100}
                                    duration={500}
                                    onClick={() => {
                                        setIsNavbarExpanded(false);
                                        setIsHamburgerOpen(false);
                                    }
                                    }
                                >ABOUT</Link>
                                <Link
                                    className="nav-link"
                                    to="testimonials-section"
                                    spy={true}
                                    smooth={true}
                                    offset={-90}
                                    duration={500}
                                    onClick={() => {
                                        setIsNavbarExpanded(false);
                                        setIsHamburgerOpen(false);
                                    }
                                    }
                                >TESTIMONIALS</Link>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>) :
                    (<Navbar.Collapse>
                        <Container className="links-container">
                            <Nav>
                                <Link
                                    className="nav-link"
                                    to="title-section"
                                    spy={true}
                                    smooth={true}
                                    offset={-100}
                                    duration={500}
                                    onClick={() => {
                                        setIsNavbarExpanded(false);
                                        setIsHamburgerOpen(false);
                                    }}
                                >HOME</Link>
                                <Link
                                    className="nav-link"
                                    to="about-section"
                                    spy={true}
                                    smooth={true}
                                    offset={-100}
                                    duration={500}
                                    onClick={() => {
                                        setIsNavbarExpanded(false);
                                        setIsHamburgerOpen(false);
                                    }
                                    }
                                >ABOUT</Link>
                                <Link
                                    className="nav-link"
                                    to="testimonials-section"
                                    spy={true}
                                    smooth={true}
                                    offset={-90}
                                    duration={500}
                                    onClick={() => {
                                        setIsNavbarExpanded(false);
                                        setIsHamburgerOpen(false);
                                    }
                                    }
                                >TESTIMONIALS</Link>
                                <div className="socials-collapse">
                                    <a href="https://www.instagram.com/dan_moral/" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} size="2x" color="white" /></a>
                                    <a href="https://www.facebook.com/daniel.morales.9484941" target="_blank" rel="noreferrer"><FontAwesomeIcon className="social-icon" icon={faFacebook} size="2x" color="white" /></a>
                                    <a href="mailto:danny5733@gmail.com" target="_blank" rel="noreferrer"><FontAwesomeIcon className="social-icon" icon={faEnvelope} size="2x" color="white" /></a>
                                </div>
                            </Nav>
                        </Container>
                    </Navbar.Collapse>)}
                <Container className="brand-container">
                    {isDesktop ?
                        (null) :
                        (<Link
                            id="apply-now-mobile"
                            className={isNavbarExpanded ? "expanded" : "closed"}
                            to="apply-section"
                            spy={true}
                            smooth={true}
                            offset={-90}
                            duration={500}
                            onClick={() => {
                                setIsNavbarExpanded(false);
                                setIsHamburgerOpen(false);
                            }}
                        ><Button id="apply-now-mobile-button">APPLY NOW!</Button></Link>)}
                    <Navbar.Brand onClick={() => {
                        scroll.scrollToTop();
                        setIsNavbarExpanded(false);
                        setIsHamburgerOpen(false);
                    }}>
                        <img
                            src={logo}
                            width="110"
                            alt="Fuerza"
                        />
                    </Navbar.Brand>
                </Container>
                <Container className="socials-container">
                    <Link
                        to="apply-section"
                        spy={true}
                        smooth={true}
                        offset={-90}
                        duration={500}
                        onClick={() => {
                            setIsNavbarExpanded(false);
                            setIsHamburgerOpen(false);
                        }}
                    ><Button className="apply-now-button">APPLY NOW!</Button></Link>
                    <div>
                        <a href="https://www.instagram.com/dan_moral/" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} size="2x" color="white" /></a>
                        <a href="https://www.facebook.com/daniel.morales.9484941" target="_blank" rel="noreferrer"><FontAwesomeIcon className="social-icon" icon={faFacebook} size="2x" color="white" /></a>
                        <a href="mailto:danny5733@gmail.com" target="_blank" rel="noreferrer"><FontAwesomeIcon className="social-icon" icon={faEnvelope} size="2x" color="white" /></a>
                    </div>
                </Container>
            </Navbar>
            <Router>
                <Switch>
                    <Route path="/">
                        <Home />
                    </Route>
                </Switch>
            </Router>
        </>
    );
}

export default App;
